/**
 * Pedalisa ana sayfa image-link-blocks: <a> etiketlerine img alt → aria-label
 */
(function () {
  function labelContentOverMediaLinks() {
    document.querySelectorAll('a.content-over-media').forEach(function (anchor) {
      if (anchor.getAttribute('aria-label')?.trim()) return
      const img = anchor.querySelector('img[alt]')
      const alt = img?.getAttribute('alt')?.trim()
      if (alt) anchor.setAttribute('aria-label', alt)
      else if (anchor.getAttribute('href')) {
        const path = anchor.getAttribute('href') || ''
        const slug = path.split('/').filter(Boolean).pop() || 'page'
        anchor.setAttribute('aria-label', slug.replace(/-/g, ' '))
      }
    })

    document.querySelectorAll('button.tap-area[aria-controls="header-sidebar-menu"]').forEach(function (btn) {
      if (!btn.getAttribute('aria-label')?.trim()) btn.setAttribute('aria-label', 'Open menu')
    })
    document.querySelectorAll('a.tap-area[aria-controls="search-drawer"]').forEach(function (link) {
      if (!link.getAttribute('aria-label')?.trim()) link.setAttribute('aria-label', 'Search')
    })
    document.querySelectorAll('a.tap-area[aria-controls="cart-drawer"]').forEach(function (link) {
      if (!link.getAttribute('aria-label')?.trim()) link.setAttribute('aria-label', 'Cart')
    })
    document.querySelectorAll('button[is="prev-button"]').forEach(function (btn) {
      if (!btn.getAttribute('aria-label')?.trim()) btn.setAttribute('aria-label', 'Previous slide')
    })
    document.querySelectorAll('button[is="next-button"]').forEach(function (btn) {
      if (!btn.getAttribute('aria-label')?.trim()) btn.setAttribute('aria-label', 'Next slide')
    })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', labelContentOverMediaLinks)
  } else {
    labelContentOverMediaLinks()
  }
  document.addEventListener('shopify:section:load', labelContentOverMediaLinks)
})()
